/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Controller } from "@hotwired/stimulus";

export default class CopyController extends Controller {
	static targets = ["content", "button"];
	declare contentTarget: HTMLElement;
	declare buttonTarget: HTMLButtonElement;

	private toast: HTMLDivElement | null = null;

	private anchorName = `--copy-button-${crypto.randomUUID()}`;

	connect() {
		// Anchor the toast to the copy button.
		(this.buttonTarget.style as any).anchorName = this.anchorName;
	}

	async copy() {
		const value = this.contentTarget.textContent.trim();

		if (!value) return;

		try {
			await navigator.clipboard.writeText(value);
			this.showToast();
		} catch (e) {
			console.error(e);
			this.showToast("Nie udało się skopiować");
		}
	}

	private showToast(message = "Skopiowano!") {
		this.removeToast();

		const toast = document.createElement("div");

		Object.assign(toast.style, {
			position: "fixed",
			positionAnchor: this.anchorName,
			positionArea: "right",
			marginLeft: "8px",

			padding: "5px 8px",
			borderRadius: "6px",
			background: "#222",
			color: "#fff",
			fontSize: "12px",
			lineHeight: "1",
			whiteSpace: "nowrap",

			opacity: "0",
			transform: "translateX(-4px)",
			transition: "opacity 120ms ease, transform 120ms ease",

			pointerEvents: "none",
			zIndex: "1000",
		});

		toast.textContent = message;

		this.element.appendChild(toast);

		requestAnimationFrame(() => {
			toast.style.opacity = "1";
			toast.style.transform = "translateX(0)";
		});

		this.toast = toast;

		setTimeout(() => {
			toast.style.opacity = "0";
			toast.style.transform = "translateX(-4px)";

			toast.addEventListener("transitionend", () => toast.remove(), {
				once: true,
			});
		}, 1500);
	}

	private removeToast() {
		this.toast?.remove();
		this.toast = null;
	}
}
